// @ts-expect-error TS(7016): Could not find a declaration file for module 'hype... Remove this comment to see the full error message
import hypernova from 'hypernova';
import { ComponentType } from 'react';

import { ssrClient } from 'ssr/client/ssrClient';
import { ssrServer } from 'ssr/server/ssrServer';
import { SsrCreateStore } from 'ssr/types/SsrCreateStore';
import { SsrProps } from 'ssr/types/SsrProps';

import { ssrHypernovaDeserializePayload } from './ssrHypernovaDeserializePayload';
import { ssrHypernovaSerializePayload } from './ssrHypernovaSerializePayload';

export function ssrHypernova(
  name: string,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>,
  createStore: SsrCreateStore,
) {
  return hypernova({
    async server() {
      return async (ssrProps: SsrProps) => {
        const response = await ssrServer({
          Component,
          createStore,
          ssrProps,
        });

        if (response.type === 'amp') return response.ampHtml;

        return ssrHypernovaSerializePayload({
          name,
          ssrProps,
          html: response.html,
          styleTags: response.styleTags,
        });
      };
    },

    async client() {
      const payload = ssrHypernovaDeserializePayload({ name });
      if (!payload) return;

      return ssrClient({ payload, Component, createStore });
    },
  });
}
